module.exports = __webpack_public_path__ + "static/media/10n.88b7ba66.svg";